import { inject } from '@angular/core';
import { CanActivateFn, Params, Router } from '@angular/router';
import { ApiService } from 'src/app/core/services/api.service';
import { findStepIdByRoute } from './auth-flow.config';
import { AuthFlowService } from '../services/auth-flow.service';
import { AuthSessionStore } from '../services/auth-session.store';
import { AuthStepId } from '../models/auth-flow.models';

const STEP_REQUIREMENTS: Partial<
  Record<AuthStepId, (store: AuthSessionStore) => boolean>
> = {
  [AuthStepId.CONFIRM_EMAIL]: (store) =>
    Boolean(store.account().login?.trim()),
  [AuthStepId.SELECT_ACCOUNT]: (store) => store.accounts().length > 0,
  [AuthStepId.TEL_VERIFICATION]: (store) =>
    Boolean(store.accountData()?.token),
  [AuthStepId.ENTER_PINCODE]: (store) =>
    store.account().id !== null && store.account().id > 0,
};

export const authStepGuard: CanActivateFn = (route) => {
  const flowService = inject(AuthFlowService);
  const store = inject(AuthSessionStore);
  const router = inject(Router);

  const stepRoute = route.routeConfig?.path ?? '';
  const stepId = stepRoute
    ? findStepIdByRoute(flowService.flowId(), stepRoute)
    : null;

  if (!stepId) {
    return true;
  }

  if (stepId === AuthStepId.ONBOARDING) {
    const api = inject(ApiService);
    if (!api.token) {
      return router.createUrlTree(flowService.getBaseCommands(), {
        queryParams: getCurrentQueryParams(router),
      });
    }
  }

  const requirement = STEP_REQUIREMENTS[stepId];
  if (requirement && !requirement(store)) {
    return router.createUrlTree(flowService.getBaseCommands(), {
      queryParams: getCurrentQueryParams(router),
    });
  }

  return true;
};

function getCurrentQueryParams(router: Router): Params {
  return (
    router.getCurrentNavigation()?.extractedUrl.queryParams ??
    router.parseUrl(router.url).queryParams
  );
}
